import logo from "../../assets/imgs/logoFsfb_header_white.svg";
import styles from "./MainHeaderLogo.module.scss";

export default function MainHeaderLogo() {
  return <img src={logo} alt="Logo FSFB" className={styles.logoFsfbHeader} />;
}
